var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTransparentBgNoshadow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    xmlns: "http://www.w3.org/2000/svg",
    height: 530,
    id: "screenshot-586a5e30-c2ab-8097-8008-572a2f720b86",
    viewBox: "0 0 530 530",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-586a5e30-c2ab-8097-8008-572a2f720b86"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-blur"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-shadows"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-586a5e30-c2ab-8097-8008-572a2f720b86"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    width: 530,
    height: 530,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    className: "frame-background"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "frame-children"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-586a5e30-c2ab-8097-8008-572a2f720b8a",
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-586a5e30-c2ab-8097-8008-572a2f720b8a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.5,50L162.5,250L87.5,250L87.5,50L0,50L0,2.2737367544323206e-13L250,2.2737367544323206e-13L250,50L162.5,50L162.5,50",
    style: {
      fill: "rgb(255, 0, 97)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-3c654a68-75c7-805d-8008-572a4b419a36-586a5e30-c2ab-8097-8008-572a2f720b8a",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.5,50L162.5,250L87.5,250L87.5,50L0,50L0,2.2737367544323206e-13L250,2.2737367544323206e-13L250,50L162.5,50L162.5,50",
    style: {
      fill: "none",
      strokeWidth: 0,
      stroke: "rgb(0, 0, 0)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-586a5e30-c2ab-8097-8008-572a2f720b89",
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-586a5e30-c2ab-8097-8008-572a2f720b89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250,280L250,530L172.131103515625,530L73.7705078125,380L73.7705078125,530L0,530L0,280L77.868896484375,280L176.2294921875,430L176.2294921875,280L250,280L250,280",
    style: {
      fill: "rgb(255, 0, 97)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-3c654a68-75c7-805d-8008-572a4b43578d-586a5e30-c2ab-8097-8008-572a2f720b89",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250,280L250,530L172.131103515625,530L73.7705078125,380L73.7705078125,530L0,530L0,280L77.868896484375,280L176.2294921875,430L176.2294921875,280L250,280L250,280",
    style: {
      fill: "none",
      strokeWidth: 0,
      stroke: "rgb(0, 0, 0)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-586a5e30-c2ab-8097-8008-572a2f720b88",
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-586a5e30-c2ab-8097-8008-572a2f720b88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.5714111328125,179.577392578125L458.5714111328125,2.2737367544323206e-13L530,2.2737367544323206e-13L530,179.577392578125C530,204.225341796875,523.7169189453125,222.124267578125,511.1507568359375,233.274658203125C498.584716796875,244.4248046875,478.4127197265625,250,450.6348876953125,250L450.6348876953125,250L359.3651123046875,250C331.5872802734375,250,311.415283203125,244.4248046875,298.8492431640625,233.274658203125C286.2830810546875,222.124267578125,280,204.225341796875,280,179.577392578125L280,179.577392578125L280,2.2737367544323206e-13L351.4285888671875,2.2737367544323206e-13L351.4285888671875,179.577392578125C351.4285888671875,193.6619873046875,359.3651123046875,200.7042236328125,375.238037109375,200.7042236328125L375.238037109375,200.7042236328125L434.761962890625,200.7042236328125C450.6348876953125,200.7042236328125,458.5714111328125,193.6619873046875,458.5714111328125,179.577392578125L458.5714111328125,179.577392578125L458.5714111328125,179.577392578125",
    style: {
      fill: "rgb(255, 0, 97)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-3c654a68-75c7-805d-8008-572a4b46f394-586a5e30-c2ab-8097-8008-572a2f720b88",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.5714111328125,179.577392578125L458.5714111328125,2.2737367544323206e-13L530,2.2737367544323206e-13L530,179.577392578125C530,204.225341796875,523.7169189453125,222.124267578125,511.1507568359375,233.274658203125C498.584716796875,244.4248046875,478.4127197265625,250,450.6348876953125,250L450.6348876953125,250L359.3651123046875,250C331.5872802734375,250,311.415283203125,244.4248046875,298.8492431640625,233.274658203125C286.2830810546875,222.124267578125,280,204.225341796875,280,179.577392578125L280,179.577392578125L280,2.2737367544323206e-13L351.4285888671875,2.2737367544323206e-13L351.4285888671875,179.577392578125C351.4285888671875,193.6619873046875,359.3651123046875,200.7042236328125,375.238037109375,200.7042236328125L375.238037109375,200.7042236328125L434.761962890625,200.7042236328125C450.6348876953125,200.7042236328125,458.5714111328125,193.6619873046875,458.5714111328125,179.577392578125L458.5714111328125,179.577392578125L458.5714111328125,179.577392578125",
    style: {
      fill: "none",
      strokeWidth: 0,
      stroke: "rgb(0, 0, 0)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-586a5e30-c2ab-8097-8008-572a2f720b87",
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-586a5e30-c2ab-8097-8008-572a2f720b87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M530,480L530,530L280,530L280,280L530,280L530,330L361.0810546875,330L361.0810546875,378.2142333984375L493.9639892578125,378.2142333984375L493.9639892578125,428.21429443359375L361.0810546875,428.21429443359375L361.0810546875,480L530,480L530,480",
    style: {
      fill: "rgb(255, 0, 97)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-3c654a68-75c7-805d-8008-572a4b495724-586a5e30-c2ab-8097-8008-572a2f720b87",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M530,480L530,530L280,530L280,280L530,280L530,330L361.0810546875,330L361.0810546875,378.2142333984375L493.9639892578125,378.2142333984375L493.9639892578125,428.21429443359375L361.0810546875,428.21429443359375L361.0810546875,480L530,480L530,480",
    style: {
      fill: "none",
      strokeWidth: 0,
      stroke: "rgb(0, 0, 0)",
      strokeOpacity: 1
    }
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTransparentBgNoshadow);
export default __webpack_public_path__ + "static/media/logo_transparent_bg_noshadow.d8464fcc485d436e4885447d090e2e59.svg";
export { ForwardRef as ReactComponent };